import Analytics from 'analytics'
import segmentPlugin from '@analytics/segment'

const segmentAnalytics = Analytics({
    app: 'GDWM',
    plugins: [
        segmentPlugin({
            writeKey: process.env.REACT_APP_SEGMENT_WRITE_KEY,
            customScriptSrc: `https://cdn.northerntrust.com/xps/analytics/${process.env.REACT_APP_SEGMENT_WRITE_KEY}/analytics-190404.min.js`,
        })
    ]
})

export default segmentAnalytics;

